import {CLOUD_PRINT_BASIC_INFO} from '@/api/print/constant'

// 获取模板
export const getTemplate = (id) => {
  return CLOUD_PRINT_BASIC_INFO.TEMPLATE.filter(item => item.id === id);
}

// 获取模板(后期改造此方法，改为从后台库中获取)
export const getTemplateFromBack = (countryFlag, type) => {
  return CLOUD_PRINT_BASIC_INFO.TEMPLATE.filter(item => item.countryFlag === countryFlag && item.type === type);
}
